export const pathes = {
  BASE_PATH: "/technical-diagnosis",
  DEFAULT: "/",
  CONDITIONS: "/conditions",
  SELECT_STATION: "/select-station",
  SELECT_VEHICLE: "/select-vehicle",
  ADD_VEHICLE: "/add-vehicle",
  // SELECT_FUEL: "/select-fuel",
  SELECT_TIME: "/select-time",
  CONFIRM_RESERVE: "/confirm-reserve",
  SUCCESS_RESERVE: "/success-reserve",
  FAIL_RESERVE: "/fail-reserve",
  RESERVE_HISTORY: "/reserve-history",
  VEHICLES: "/vehicles",
  VEHICLE_INFORMATION: "/vehicle-information",
  DEBT_RECORDS: "/debt-records",
  DEBT_FACTOR: "/debt-factor",
  DEBT_SUCCESS_PAGE: "/debt-success-page",
  DEBT_FAIL_PAGE: "/debt-fail-page",
  ACCOUNT: "/account",
};

export const flowPathes = {
  AFTER_SELECT_CAR: pathes.CONDITIONS,
  AFTER_ADD_CAR: pathes.SELECT_VEHICLE,
  AFTER_SUCCESS_PAY_DEBT: pathes.SELECT_VEHICLE,
  AFTER_FAIL_PAY_DEBT: pathes.SELECT_VEHICLE,
  ON_VEHICLE_INFO: pathes.CONDITIONS,
};
